import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';
import { FieldArray } from 'redux-form';
import { requiredArray } from '../../../util/validators';
import React from 'react';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { retirementAccountsInitialValue } from '../../../util/initial-values';
import { RETIREMENT_ACCOUNT_TYPE_OPTIONS } from '../../../models/options/options';

const retirementInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.financialStatementFinancialInstitution,
    isOptional : false,
    label      : 'Financial Institution',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.financialStatementRetirementType,
    isOptional : false,
    label      : 'Account Type',
    options    : RETIREMENT_ACCOUNT_TYPE_OPTIONS,
    type       : DynamicFormFieldArrayType.SELECT,
  },
  {
    fieldName  : FieldNames.financialStatementMarketValue,
    isOptional : false,
    label      : 'Market Value',
    type       : DynamicFormFieldArrayType.CURRENCY,
  },
  {
    fieldName  : FieldNames.financialStatementJointAccount,
    isOptional : false,
    label      : 'Is this held jointly',
    type       : DynamicFormFieldArrayType.Y_N_SWITCH_TOGGLE,
  },
];

const retirementProps: DynamicFormFieldArray = {
  addButtonText: 'Account',
  initialValue: retirementAccountsInitialValue,
  inputs: retirementInputs,
};

export const RetirementAccountsFFAComponent = ({ ...props }) => {
  const { name, options } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = { name }
        props     = { { dynamicProps: retirementProps, name, t, options } }
        validate  = {[
          requiredArray([]),
        ]}
      />
    </FormControl>
  );
};
